import { useEffect, useRef } from 'react';

import { Section } from '~components/Section/Section';
import { useBreakpoints } from '~hooks/useBreakpoints';

import { ContentBlockWrapperProps } from './ContentBlockWrapper.types';

// Обертка блоков для навигации по AnchorMenu
export function ContentBlockWrapper({
  registerSection,
  unregisterSection,
  hash,
  children,
  ...sectionProps
}: ContentBlockWrapperProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [, { isMobile }] = useBreakpoints();

  useEffect(() => {
    if (
      isMobile ||
      !ref.current ||
      !hash ||
      !registerSection ||
      !unregisterSection
    )
      return;

    registerSection(hash, ref.current);

    return () => unregisterSection(hash);
  }, [isMobile, registerSection, unregisterSection, hash]);

  return (
    <Section {...sectionProps} ref={ref} hash={hash}>
      {children}
    </Section>
  );
}
